import React from 'react';
import ReactDOM from 'react-dom';

import Main from './components/Main';

import './index.css';

ReactDOM.render(
  <Main />,
  document.getElementById('root')
);
